/* Progressive enhancement only. Core navigation, forms and checkout work without JS. */
(() => {
  function initProducts(root = document) {
    root.querySelectorAll('[data-product-panel]').forEach((panel) => {
      if (panel.dataset.enhanced) return;
      panel.dataset.enhanced = 'true';
      const selector = panel.querySelector('[name="id"]');
      const button = panel.querySelector('[data-add-button]');
      const price = panel.querySelector('[data-variant-price]');
      const compare = panel.querySelector('[data-variant-compare]');
      const sku = panel.querySelector('[data-variant-sku]');
      const unit = panel.querySelector('[data-variant-unit]');
      const quantity = panel.querySelector('[name="quantity"]');
      if (!selector || selector.tagName !== 'SELECT') return;
      selector.addEventListener('change', () => {
        const option = selector.options[selector.selectedIndex];
        if (!option) return;
        if (price) price.textContent = option.dataset.price || '';
        if (compare) {
          compare.textContent = option.dataset.compare || '';
          compare.hidden = !option.dataset.compare;
        }
        if (sku) {
          sku.textContent = option.dataset.sku || '';
          sku.parentElement.hidden = !option.dataset.sku;
        }
        if (unit) {
          unit.textContent = option.dataset.unit || '';
          unit.hidden = !option.dataset.unit;
        }
        if (button) {
          button.disabled = option.dataset.available !== 'true';
          button.textContent = button.disabled ? panel.dataset.soldOut : panel.dataset.addLabel;
        }
        if (quantity) {
          quantity.min = option.dataset.min || '1';
          quantity.step = option.dataset.increment || '1';
          if (option.dataset.max) quantity.max = option.dataset.max;
          else quantity.removeAttribute('max');
          quantity.value = quantity.min;
        }
        if (panel.dataset.updateUrl === 'true' && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          window.history.replaceState({}, '', url);
        }
        if (option.dataset.media) {
          const media = document.getElementById(option.dataset.media);
          if (media) media.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
        }
      });
    });
  }
  initProducts();
  document.addEventListener('shopify:section:load', (event) => initProducts(event.target));
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('details.nav-dropdown[open], details.mobile-menu[open]').forEach((details) => {
      details.open = false;
      details.querySelector('summary')?.focus();
    });
  });
})();
